<template>
    <div
        class="md-banner layout2 mg-bg"
        :style="{
            ...spaceStyle,
            ...colorStyle
        }"
        :class="{
            mobile: isMobileSize,
            'mg-container': !fullColumn,
            'mobile-no-margin': mobileNoMargin,
            revert: revert
        }"
    >
        <div class="content-wrapper f-col-2" :class="align" v-animated="textAnimation">
            <site-title
                :title="title"
                :align="align"
            />
            <site-p
                :text="subTitle"
                :size="16"
                :mbSize="16"
                :align="align"
            />
        </div>
        <banner
            v-if="hideDefault"
            ref="banner"
            :class="{
                'mg-container': !fullColumn,
                'mobile-no-margin': mobileNoMargin
            }"
            :type="type"
            :mobileType="mobileType"
            :pictureOption="pictureOption"
            :pictureListOption="pictureListOption"
            :rawDot="true"
            v-animated="{name: 'fade-in', duration: 1500, enable: showAnimationEffects}"
        />
        <div class="banner default-wrap" v-else v-animated="{name: 'fade-in', duration: 1500, enable: showAnimationEffects}">
            <site-img :src="defaultImgSrc" dir="width" />
        </div>
    </div>
</template>

<script>
import common from '../index-layout';
import util from '@/common/util';
export default {
    name: 'MdBannerLayout2',
    mixins: [common],
    data: function() {
        return {
            revert: false,
            defaultImgSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/default-img.png'
        }
    },
    computed: {
        textAnimation() {
            return {
                name: this.isMobileSize ? 'shift-right' : (!this.revert ? 'shift-right' : 'shift-left'),
                enable: this.showAnimationEffects
            }
        },
        pictureSrc() {
            return util.getImgSrcByPlatform(this.pictureOption, this.isMobileSize);
        },
        hideDefault() {
            let { type, pictureListOption } = this;
            if (type == 'single') {
                return this.pictureSrc ? true : false;
            } else {
                let { list, mobileList } = pictureListOption || {};
                return list?.length || mobileList?.length ? true : false;
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.md-banner.layout2 {
    display: flex;
    min-height: 560px;
    justify-content: flex-end;
    .banner {
        width: 50%;
        position: relative;
        aspect-ratio: 720 / 520;
        &.default-wrap {
            background: rgba(218, 218, 218, 0.2);
            img {
                width: 64px;
                height: 56px;
                opacity: 0.3;
            }
        }
    }
    .content-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0 50px 0 0;
        &.left{
            align-items: flex-start;
        }
        &.center{
            align-items: center;
        }
        &.right{
            align-items: flex-end;
        }
        .site-title{
            margin-bottom: 28px;
        }
    }
    &.revert{
        flex-direction: row-reverse;
        .content-wrapper {
            padding: 0 0 0 50px;
        }
    }
    &.mobile {
        height: fit-content;
        min-height: auto;
        flex-direction: column-reverse;
        &.revert{
            flex-direction: column;
        }
        .banner {
            width: 100%;
            &.default-wrap {
                min-height: 250px;
            }
        }
        .img-wrapper {
            width: 100%;
            height: var(--mobile-video-height);
        }
        .content-wrapper {
            padding: 20px 15px 40px;
            .site-title{
                margin-bottom: 12px;
            }
        }
    }

    @include media-600 {
        min-height: auto;
        flex-direction: column-reverse;
        .banner{
            width: 100%;
            height: 300px;
        }
        .content-wrapper{
            padding: 30px 15px;
        }
        &.revert{
            flex-direction: column-reverse;
            .content-wrapper{
                padding: 30px 15px;
            }
        }
    }
}
</style>
